module.exports = __webpack_public_path__ + "media/2x/4-15600adc.png";